// src/components/ProductStockSection.tsx
'use client';
import { useRef, useState, createContext, useContext, RefObject } from 'react';
import StockCheckButton from './StockCheckButton';
import OfflineStockButton from './OfflineStockButton';

// Создаем контекст для общего состояния
const StockContext = createContext<{
    hasOfflineStock: boolean;
    setHasOfflineStock: (value: boolean) => void;
    stockRef: RefObject<HTMLDivElement | null>;
    scrollToStock: () => void;
}>({
    hasOfflineStock: false,
    setHasOfflineStock: () => { },
    stockRef: { current: null },
    scrollToStock: () => { }
});

// Провайдер для обертки
export function ProductStockProvider({ children }: { children: React.ReactNode }) {
    const stockRef = useRef<HTMLDivElement | null>(null);
    const [hasOfflineStock, setHasOfflineStock] = useState(false);

    const scrollToStock = () => {
        if (stockRef.current) {
            const elementPosition = stockRef.current.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 90;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <StockContext.Provider value={{ hasOfflineStock, setHasOfflineStock, stockRef, scrollToStock }}>
            {children}
        </StockContext.Provider>
    );
}

interface ProductStockSectionProps {
    sku: string;
    productName: string;
    productImage: string;
    inStock: boolean;
    status?: boolean;
    storeList?: boolean;
}

export default function ProductStockSection({
    sku,
    productName,
    productImage,
    inStock,
    status = false,
    storeList = false
}: ProductStockSectionProps) {
    const { hasOfflineStock, setHasOfflineStock, stockRef, scrollToStock } = useContext(StockContext);

    // Если нужен только статус с кнопкой
    if (status) {
        return (
            <div className="flex items-center md:justify-start justify-between">
                <div className={`stock_status ${inStock ? '' : 'out_of_stock'}`}>
                    <span className={inStock ? '' : 'out_of_stock'}>
                        {inStock ? 'В наличии' : 'Нет в наличии'}
                    </span>
                </div>
                {!inStock && hasOfflineStock && (
                    <OfflineStockButton onClick={scrollToStock} />
                )}
            </div>
        );
    }

    // Если нужен только список магазинов
    if (storeList) {
        return (
            <div className="product_buttons_block-">
                <StockCheckButton
                    ref={stockRef}
                    sku={sku}
                    productName={productName}
                    productImage={productImage}
                    onStockLoad={setHasOfflineStock}
                />
            </div>
        );
    }

    return null;
}